// extracted by mini-css-extract-plugin
export default {"control":"styles_control__yx292"};